export * from './your-situation';
export type { YourSituationResultProps } from './your-situation.types';
export { questionsMap } from './questions-map';
export { checkResponseType } from './helper/checkResponseType';
